let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("01GzB")).then(() => parcelRequire('bpTxi'));